import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface DialogHeaderProps {
  children: ReactNode;
}

const DialogHeader = ({ children }: DialogHeaderProps) => {
  return (
    <Box
      sx={{
        p: 3,
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      {children}
    </Box>
  );
};

export default DialogHeader; 